var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounFailed3977955(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0C7.178,0,0,7.178,0,16s7.178,16,16,16s16-7.178,16-16S24.822,0,16,0z M21.835,20.445  c0.389,0.392,0.388,1.025-0.003,1.415c-0.195,0.194-0.451,0.291-0.706,0.291c-0.257,0-0.513-0.098-0.709-0.294l-4.42-4.441  l-4.441,4.42c-0.195,0.194-0.451,0.291-0.706,0.291c-0.257,0-0.513-0.098-0.709-0.294c-0.389-0.392-0.388-1.025,0.003-1.415  l4.441-4.42l-4.42-4.441c-0.389-0.392-0.388-1.025,0.003-1.415c0.392-0.39,1.024-0.388,1.415,0.003l4.42,4.441l4.441-4.42  c0.392-0.39,1.024-0.388,1.415,0.003c0.389,0.392,0.388,1.025-0.003,1.415l-4.441,4.42L21.835,20.445z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounFailed3977955);
export default __webpack_public_path__ + "static/media/noun_failed_3977955.f6e63a0e.svg";
export { ForwardRef as ReactComponent };